const mutations = {
  mutationPrivileges(state, payload) {
    state.privileges = payload;
  },

  mutationPrivilege(state, payload) {
    state.privilege = payload;
  },

  mutationPermissions(state, payload) {
    state.permissions = payload;
  },
};

export default mutations;
